import axios from 'axios';
import { newAbortSignal } from '../../utils';
import { SessionStore } from '../../types/store/SessionStore';
import { QuestionNotificationResponse } from '../../types/model/stage/QuestionNotificationResponse';

const BASE_URL = `${process.env.REACT_APP_BACKEND_URL}/project/notifications/new-questions`;

export const getNewQuestionNotifications = async (): Promise<QuestionNotificationResponse[]> => {
  const session: SessionStore | undefined = JSON.parse(localStorage.getItem('session') || '{}');

  if (!session?.accessToken) {
    return [];
  }

  return await axios
    .get<QuestionNotificationResponse[]>(BASE_URL, {
      headers: {
        'content-type': 'application/json',
        'x-access-token': session.accessToken,
      },
      timeout: parseInt(`${process.env.REACT_APP_AXIOS_TIME_OUT}`),
      signal:
        typeof AbortSignal.timeout !== 'undefined'
          ? AbortSignal.timeout(parseInt(`${process.env.REACT_APP_AXIOS_TIME_OUT}`))
          : newAbortSignal(parseInt(`${process.env.REACT_APP_AXIOS_TIME_OUT}`)),
    })
    .then((response) => response.data)
    .catch((error) => {
      return [];
    });
};
